export const FONT_FAMILY = {
    ROBOTO_THIN: "roboto-thin",
    ROBOTO_THIN_ITALIC: "roboto-thin-italic",
    ROBOTO_LIGHT: "roboto-light",
    ROBOTO_LIGHT_ITALIC: "roboto-light-italic",
    ROBOTO_REGULAR: "roboto",
    ROBOTO_REGULAR_ITALIC: "roboto-italic",
    ROBOTO_MEDIUM: "roboto-medium",
    ROBOTO_MEDIUM_ITALIC: "roboto-medium-italic",
    ROBOTO_BOLD: "roboto-bold",
    ROBOTO_BOLD_ITALIC: "roboto-bold-italic",
    ROBOTO_BLACK: "roboto-black",
    ROBOTO_BLACK_ITALIC: "roboto-black-italic",
    CAPITOLIUM: "capitolium",
    CAPITOLIUM_ITALIC: "capitolium-italic",
    CAPITOLIUM_BOLD: "capitolium-bold",
    PLUS_JAKARTA_SANS_EXTRABOLD: "plus-jakarta-sans-extrabold",
    PLUS_JAKARTA_SANS_EXTRABOLD_ITALIC: "plus-jakarta-sans-extrabold-italic",
    PLUS_JAKARTA_SANS_BOLD: "plus-jakarta-sans-bold",
    PLUS_JAKARTA_SANS_BOLD_ITALIC: "plus-jakarta-sans-bold-italic",
    PLUS_JAKARTA_SANS_SEMIBOLD: "plus-jakarta-sans-semibold",
    PLUS_JAKARTA_SANS_SEMIBOLD_ITALIC: "plus-jakarta-sans-semibold-italic",
    PLUS_JAKARTA_SANS_MEDIUM: "plus-jakarta-sans-medium",
    PLUS_JAKARTA_SANS_MEDIUM_ITALIC: "plus-jakarta-sans-medium-italic",
    PLUS_JAKARTA_SANS_REGULAR: "plus-jakarta-sans-regular",
    PLUS_JAKARTA_SANS_REGULAR_ITALIC: "plus-jakarta-sans-regular-italic",
    PLUS_JAKARTA_SANS_LIGHT: "plus-jakarta-sans-light",
    PLUS_JAKARTA_SANS_LIGHT_ITALIC: "plus-jakarta-sans-light-italic",
    PLUS_JAKARTA_SANS_EXTRALIGHT: "plus-jakarta-sans-extralight",
    PLUS_JAKARTA_SANS_EXTRALIGHT_ITALIC: "plus-jakarta-sans-extralight-italic",
};
